import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

const useCameraPlayerPageStyles = makeStyles(({ spacing, palette }) =>
  createStyles({
    logo: {
      height: 20,
      position: 'fixed',
      top: spacing(3),
      left: spacing(2),
    },
    toolbar: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'center',
      color: palette.primary.contrastText,
      backgroundColor: palette.primary.dark,
      height: spacing(8),
    },
    cameraPlayerPageWrapper: {
      backgroundColor: palette.common.black,
      width: '100%',
    },
    cameraPlayerWrapper: {
      position: 'relative',
      height: `calc(100% - ${spacing(12)})`,
    },
  })
);

export default useCameraPlayerPageStyles;
